import { render, staticRenderFns } from "./MilestonesDead.vue?vue&type=template&id=58fdd0c1&"
import script from "./MilestonesDead.vue?vue&type=script&lang=js&"
export * from "./MilestonesDead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports